import { User, Client, Visit, ActivityLog, Invoice } from '../types'

export const mockUsers: User[] = [
  {
    id: '1',
    nombre: 'Carlos Administrador',
    email: 'admin@empresa.com',
    password: 'admin123',
    rol: 'admin',
    activo: true,
    fechaCreacion: new Date('2024-01-01'),
  },
  {
    id: '2',
    nombre: 'María García',
    email: 'maria@empresa.com',
    password: 'vendedor123',
    rol: 'vendedor',
    activo: true,
    fechaCreacion: new Date('2024-01-15'),
  },
  {
    id: '3',
    nombre: 'Juan Pérez',
    email: 'juan@empresa.com',
    password: 'vendedor123',
    rol: 'vendedor',
    activo: true,
    fechaCreacion: new Date('2024-02-01'),
  },
  {
    id: '4',
    nombre: 'Ana López',
    email: 'ana@empresa.com',
    password: 'vendedor123',
    rol: 'vendedor',
    activo: true,
    fechaCreacion: new Date('2024-02-15'),
  },
  {
    id: '5',
    nombre: 'Roberto Sánchez',
    email: 'roberto@empresa.com',
    password: 'vendedor123',
    rol: 'vendedor',
    activo: false,
    fechaCreacion: new Date('2024-03-01'),
  },
]

export const mockClients: Client[] = [
  {
    id: '1',
    nombre: 'Farmacia Carol',
    zona: 'Zona Colonial',
    direccion: 'Calle El Conde #45, Santo Domingo',
    telefono: '809-555-0101',
    contacto: 'Dr. Martínez',
  },
  {
    id: '2',
    nombre: 'Farmacia La Salud',
    zona: 'Piantini',
    direccion: 'Av. Abraham Lincoln #234, Santo Domingo',
    telefono: '809-555-0102',
    contacto: 'Lic. Rodríguez',
  },
  {
    id: '3',
    nombre: 'Farmacia del Pueblo',
    zona: 'Santiago Centro',
    direccion: 'Calle del Sol #12, Santiago',
    telefono: '809-555-0103',
    contacto: 'Sra. González',
  },
  {
    id: '4',
    nombre: 'Farmacia Central',
    zona: 'Naco',
    direccion: 'Av. Tiradentes #89, Santo Domingo',
    telefono: '809-555-0104',
    contacto: 'Dr. Hernández',
  },
  {
    id: '5',
    nombre: 'Farmacia Nueva Vida',
    zona: 'La Romana',
    direccion: 'Av. Padre Abreu #56, La Romana',
    telefono: '809-555-0105',
    contacto: 'Lic. Morales',
  },
  {
    id: '6',
    nombre: 'Farmacia El Ángel',
    zona: 'San Pedro',
    direccion: 'Calle Duarte #78, San Pedro de Macorís',
    telefono: '809-555-0106',
    contacto: 'Sra. Díaz',
  },
  {
    id: '7',
    nombre: 'Farmacia Bienestar',
    zona: 'Puerto Plata',
    direccion: 'Av. Circunvalación Norte #23, Puerto Plata',
    telefono: '809-555-0107',
    contacto: 'Dr. Castro',
  },
  {
    id: '8',
    nombre: 'Farmacia Express',
    zona: 'Los Prados',
    direccion: 'Av. Ortega y Gasset #145, Santo Domingo',
    telefono: '809-555-0108',
    contacto: 'Lic. Vargas',
  },
]

// Helper to create dates without mutation
function makeDate(daysAgo: number, hours: number, minutes: number): Date {
  const d = new Date()
  d.setDate(d.getDate() - daysAgo)
  d.setHours(hours, minutes, 0, 0)
  return d
}

function todayDate(): Date {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

function daysAgoDate(days: number): Date {
  const d = new Date()
  d.setDate(d.getDate() - days)
  d.setHours(0, 0, 0, 0)
  return d
}

function futureDate(days: number): Date {
  const d = new Date()
  d.setDate(d.getDate() + days)
  d.setHours(0, 0, 0, 0)
  return d
}

export const mockVisits: Visit[] = [
  // === HOY - María García ===
  {
    id: '1',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '1',
    clienteNombre: 'Farmacia Carol',
    zona: 'Zona Colonial',
    tipoVisita: 'cobro_y_venta',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 9, 0),
    horaSalida: makeDate(0, 9, 45),
    tiempoTotal: 45,
    cobro: {
      huboCobo: true,
      montoCobrado: 15000,
      metodoPago: 'transferencia',
      numeroFactura: 'FAC-001',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 8500, numeroPedido: 'PED-001' },
    comentarios: 'Cliente satisfecho, solicita más producto la próxima semana',
    motivoNoPago: '',
    proximaVisita: futureDate(7),
    estado: 'completada',
  },
  {
    id: '2',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '2',
    clienteNombre: 'Farmacia La Salud',
    zona: 'Piantini',
    tipoVisita: 'cobro',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 10, 30),
    horaSalida: makeDate(0, 11, 0),
    tiempoTotal: 30,
    cobro: {
      huboCobo: true,
      montoCobrado: 5000,
      metodoPago: 'efectivo',
      numeroFactura: 'FAC-002',
      estadoFactura: 'pago_parcial',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Pago parcial, completará la próxima semana',
    motivoNoPago: '',
    proximaVisita: futureDate(5),
    estado: 'completada',
  },
  {
    id: '20',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '7',
    clienteNombre: 'Farmacia Bienestar',
    zona: 'Puerto Plata',
    tipoVisita: 'venta',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 12, 0),
    horaSalida: makeDate(0, 12, 35),
    tiempoTotal: 35,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: true, montoVenta: 6200, numeroPedido: 'PED-010' },
    comentarios: 'Pedido de reposición mensual',
    motivoNoPago: '',
    proximaVisita: futureDate(30),
    estado: 'completada',
  },
  // === HOY - Juan Pérez ===
  {
    id: '3',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '3',
    clienteNombre: 'Farmacia del Pueblo',
    zona: 'Santiago Centro',
    tipoVisita: 'venta',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 9, 15),
    horaSalida: makeDate(0, 10, 0),
    tiempoTotal: 45,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: true, montoVenta: 12000, numeroPedido: 'PED-002' },
    comentarios: 'Nuevo pedido grande, cliente en expansión',
    motivoNoPago: '',
    proximaVisita: futureDate(14),
    estado: 'completada',
  },
  {
    id: '4',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '4',
    clienteNombre: 'Farmacia Central',
    zona: 'Naco',
    tipoVisita: 'seguimiento',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 11, 0),
    horaSalida: makeDate(0, 11, 20),
    tiempoTotal: 20,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Seguimiento de pedido anterior, todo en orden',
    motivoNoPago: '',
    proximaVisita: null,
    estado: 'completada',
  },
  // === HOY - Ana López (en progreso) ===
  {
    id: '5',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '5',
    clienteNombre: 'Farmacia Nueva Vida',
    zona: 'La Romana',
    tipoVisita: 'cobro',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 9, 30),
    horaSalida: null,
    tiempoTotal: null,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: 'FAC-003',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: '',
    motivoNoPago: '',
    proximaVisita: null,
    estado: 'en_progreso',
  },
  {
    id: '21',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '8',
    clienteNombre: 'Farmacia Express',
    zona: 'Los Prados',
    tipoVisita: 'cobro_y_venta',
    fecha: todayDate(),
    horaLlegada: makeDate(0, 8, 0),
    horaSalida: makeDate(0, 8, 50),
    tiempoTotal: 50,
    cobro: {
      huboCobo: true,
      montoCobrado: 8500,
      metodoPago: 'efectivo',
      numeroFactura: 'FAC-010',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 4300, numeroPedido: 'PED-011' },
    comentarios: 'Buen cliente, siempre puntual',
    motivoNoPago: '',
    proximaVisita: futureDate(7),
    estado: 'completada',
  },
  // === AYER ===
  {
    id: '6',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '6',
    clienteNombre: 'Farmacia El Ángel',
    zona: 'San Pedro',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(1),
    horaLlegada: makeDate(1, 14, 0),
    horaSalida: makeDate(1, 15, 0),
    tiempoTotal: 60,
    cobro: {
      huboCobo: true,
      montoCobrado: 22000,
      metodoPago: 'cheque',
      numeroFactura: 'FAC-004',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 15000, numeroPedido: 'PED-003' },
    comentarios: 'Excelente relación con el cliente',
    motivoNoPago: '',
    proximaVisita: futureDate(10),
    estado: 'completada',
  },
  {
    id: '7',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '3',
    clienteNombre: 'Farmacia del Pueblo',
    zona: 'Santiago Centro',
    tipoVisita: 'cobro',
    fecha: daysAgoDate(1),
    horaLlegada: makeDate(1, 9, 0),
    horaSalida: makeDate(1, 9, 40),
    tiempoTotal: 40,
    cobro: {
      huboCobo: true,
      montoCobrado: 7500,
      metodoPago: 'transferencia',
      numeroFactura: 'FAC-005',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Cobro completo de factura pendiente',
    motivoNoPago: '',
    proximaVisita: futureDate(14),
    estado: 'completada',
  },
  {
    id: '8',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '1',
    clienteNombre: 'Farmacia Carol',
    zona: 'Zona Colonial',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(1),
    horaLlegada: makeDate(1, 10, 0),
    horaSalida: makeDate(1, 10, 55),
    tiempoTotal: 55,
    cobro: {
      huboCobo: true,
      montoCobrado: 18000,
      metodoPago: 'transferencia',
      numeroFactura: 'FAC-006',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 9500, numeroPedido: 'PED-004' },
    comentarios: 'Pedido mensual recurrente',
    motivoNoPago: '',
    proximaVisita: futureDate(30),
    estado: 'completada',
  },
  {
    id: '9',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '7',
    clienteNombre: 'Farmacia Bienestar',
    zona: 'Puerto Plata',
    tipoVisita: 'venta',
    fecha: daysAgoDate(1),
    horaLlegada: makeDate(1, 11, 30),
    horaSalida: makeDate(1, 12, 15),
    tiempoTotal: 45,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: true, montoVenta: 11000, numeroPedido: 'PED-005' },
    comentarios: 'Nuevo producto bien recibido',
    motivoNoPago: '',
    proximaVisita: futureDate(7),
    estado: 'completada',
  },
  // === 2 DÍAS ATRÁS ===
  {
    id: '10',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '4',
    clienteNombre: 'Farmacia Central',
    zona: 'Naco',
    tipoVisita: 'cobro',
    fecha: daysAgoDate(2),
    horaLlegada: makeDate(2, 9, 0),
    horaSalida: makeDate(2, 9, 30),
    tiempoTotal: 30,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: 'FAC-007',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: '',
    motivoNoPago:
      'Cliente sin flujo de caja esta semana, promete pagar el viernes',
    proximaVisita: futureDate(3),
    estado: 'completada',
  },
  {
    id: '11',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '5',
    clienteNombre: 'Farmacia Nueva Vida',
    zona: 'La Romana',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(2),
    horaLlegada: makeDate(2, 10, 0),
    horaSalida: makeDate(2, 11, 0),
    tiempoTotal: 60,
    cobro: {
      huboCobo: true,
      montoCobrado: 12500,
      metodoPago: 'cheque',
      numeroFactura: 'FAC-008',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 7800, numeroPedido: 'PED-006' },
    comentarios: 'Cliente ampliando inventario',
    motivoNoPago: '',
    proximaVisita: futureDate(14),
    estado: 'completada',
  },
  {
    id: '12',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '2',
    clienteNombre: 'Farmacia La Salud',
    zona: 'Piantini',
    tipoVisita: 'seguimiento',
    fecha: daysAgoDate(2),
    horaLlegada: makeDate(2, 14, 0),
    horaSalida: makeDate(2, 14, 25),
    tiempoTotal: 25,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Verificación de stock, todo en orden',
    motivoNoPago: '',
    proximaVisita: futureDate(7),
    estado: 'completada',
  },
  // === 3 DÍAS ATRÁS ===
  {
    id: '13',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '8',
    clienteNombre: 'Farmacia Express',
    zona: 'Los Prados',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(3),
    horaLlegada: makeDate(3, 8, 30),
    horaSalida: makeDate(3, 9, 20),
    tiempoTotal: 50,
    cobro: {
      huboCobo: true,
      montoCobrado: 9800,
      metodoPago: 'efectivo',
      numeroFactura: 'FAC-009',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 5600, numeroPedido: 'PED-007' },
    comentarios: 'Reposición de inventario mensual',
    motivoNoPago: '',
    proximaVisita: futureDate(28),
    estado: 'completada',
  },
  {
    id: '14',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '6',
    clienteNombre: 'Farmacia El Ángel',
    zona: 'San Pedro',
    tipoVisita: 'cobro',
    fecha: daysAgoDate(3),
    horaLlegada: makeDate(3, 11, 0),
    horaSalida: makeDate(3, 11, 35),
    tiempoTotal: 35,
    cobro: {
      huboCobo: true,
      montoCobrado: 6300,
      metodoPago: 'transferencia',
      numeroFactura: 'FAC-010',
      estadoFactura: 'pago_parcial',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Pago parcial, saldo pendiente $3,700',
    motivoNoPago: '',
    proximaVisita: futureDate(5),
    estado: 'completada',
  },
  {
    id: '15',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '1',
    clienteNombre: 'Farmacia Carol',
    zona: 'Zona Colonial',
    tipoVisita: 'venta',
    fecha: daysAgoDate(3),
    horaLlegada: makeDate(3, 13, 0),
    horaSalida: makeDate(3, 13, 40),
    tiempoTotal: 40,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: '',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: true, montoVenta: 14200, numeroPedido: 'PED-008' },
    comentarios: 'Pedido especial para temporada alta',
    motivoNoPago: '',
    proximaVisita: futureDate(10),
    estado: 'completada',
  },
  // === 4-5 DÍAS ATRÁS ===
  {
    id: '16',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '5',
    clienteNombre: 'Farmacia Nueva Vida',
    zona: 'La Romana',
    tipoVisita: 'cobro',
    fecha: daysAgoDate(4),
    horaLlegada: makeDate(4, 9, 0),
    horaSalida: makeDate(4, 9, 25),
    tiempoTotal: 25,
    cobro: {
      huboCobo: true,
      montoCobrado: 11000,
      metodoPago: 'transferencia',
      numeroFactura: 'FAC-011',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: 'Cobro puntual',
    motivoNoPago: '',
    proximaVisita: futureDate(14),
    estado: 'completada',
  },
  {
    id: '17',
    vendedorId: '3',
    vendedorNombre: 'Juan Pérez',
    clienteId: '7',
    clienteNombre: 'Farmacia Bienestar',
    zona: 'Puerto Plata',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(4),
    horaLlegada: makeDate(4, 10, 30),
    horaSalida: makeDate(4, 11, 30),
    tiempoTotal: 60,
    cobro: {
      huboCobo: true,
      montoCobrado: 16500,
      metodoPago: 'cheque',
      numeroFactura: 'FAC-012',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 10200, numeroPedido: 'PED-009' },
    comentarios: 'Renovación de contrato anual',
    motivoNoPago: '',
    proximaVisita: futureDate(30),
    estado: 'completada',
  },
  {
    id: '18',
    vendedorId: '4',
    vendedorNombre: 'Ana López',
    clienteId: '3',
    clienteNombre: 'Farmacia del Pueblo',
    zona: 'Santiago Centro',
    tipoVisita: 'cobro',
    fecha: daysAgoDate(5),
    horaLlegada: makeDate(5, 14, 0),
    horaSalida: makeDate(5, 14, 30),
    tiempoTotal: 30,
    cobro: {
      huboCobo: false,
      montoCobrado: 0,
      metodoPago: null,
      numeroFactura: 'FAC-013',
      estadoFactura: 'no_pago',
    },
    venta: { huboVenta: false, montoVenta: 0, numeroPedido: '' },
    comentarios: '',
    motivoNoPago: 'Encargado no disponible, reprogramar visita',
    proximaVisita: futureDate(2),
    estado: 'completada',
  },
  {
    id: '19',
    vendedorId: '2',
    vendedorNombre: 'María García',
    clienteId: '4',
    clienteNombre: 'Farmacia Central',
    zona: 'Naco',
    tipoVisita: 'cobro_y_venta',
    fecha: daysAgoDate(5),
    horaLlegada: makeDate(5, 10, 0),
    horaSalida: makeDate(5, 10, 50),
    tiempoTotal: 50,
    cobro: {
      huboCobo: true,
      montoCobrado: 13200,
      metodoPago: 'efectivo',
      numeroFactura: 'FAC-014',
      estadoFactura: 'pagada_completa',
    },
    venta: { huboVenta: true, montoVenta: 7100, numeroPedido: 'PED-010' },
    comentarios: 'Pedido regular más productos nuevos',
    motivoNoPago: '',
    proximaVisita: futureDate(14),
    estado: 'completada',
  },
]

export const mockActivityLogs: ActivityLog[] = [
  {
    id: '1',
    userId: '2',
    userName: 'María García',
    action: 'Inicio de sesión',
    timestamp: makeDate(0, 8, 30),
    location: { lat: 18.473, lng: -69.883, timestamp: new Date() },
    details: 'Acceso desde dispositivo móvil',
  },
  {
    id: '2',
    userId: '2',
    userName: 'María García',
    action: 'Inicio de visita',
    timestamp: makeDate(0, 9, 0),
    location: { lat: 18.473, lng: -69.883, timestamp: new Date() },
    details: 'Farmacia Carol',
  },
  {
    id: '3',
    userId: '3',
    userName: 'Juan Pérez',
    action: 'Inicio de sesión',
    timestamp: makeDate(0, 9, 0),
    location: { lat: 19.4517, lng: -70.697, timestamp: new Date() },
    details: 'Acceso desde dispositivo móvil',
  },
  {
    id: '4',
    userId: '3',
    userName: 'Juan Pérez',
    action: 'Registro de venta',
    timestamp: makeDate(0, 10, 0),
    location: { lat: 19.4517, lng: -70.697, timestamp: new Date() },
    details: 'Venta por $12,000 - Farmacia del Pueblo',
  },
  {
    id: '5',
    userId: '4',
    userName: 'Ana López',
    action: 'Inicio de sesión',
    timestamp: makeDate(0, 7, 50),
    location: { lat: 18.4273, lng: -68.9728, timestamp: new Date() },
    details: 'Acceso desde dispositivo móvil',
  },
  {
    id: '6',
    userId: '4',
    userName: 'Ana López',
    action: 'Cobro registrado',
    timestamp: makeDate(0, 8, 50),
    location: { lat: 18.495, lng: -69.91, timestamp: new Date() },
    details: 'Cobro $8,500 - Farmacia Express',
  },
  {
    id: '7',
    userId: '1',
    userName: 'Carlos Administrador',
    action: 'Inicio de sesión',
    timestamp: makeDate(0, 8, 0),
    location: { lat: 18.473, lng: -69.883, timestamp: new Date() },
    details: 'Acceso desde escritorio',
  },
]

export const mockInvoices: Invoice[] = [
  // Farmacia Carol (id: 1)
  {
    id: '101',
    clientId: '1',
    farmacia: 'Farmacia Carol',
    vendedor: 'María García',
    fechaEmision: daysAgoDate(45),
    fechaVencimiento: daysAgoDate(15),
    monto: 15000,
    saldoPendiente: 15000,
    estado: 'vencida',
    numeroFactura: 'FAC-2024-001',
  },
  {
    id: '102',
    clientId: '1',
    farmacia: 'Farmacia Carol',
    vendedor: 'María García',
    fechaEmision: daysAgoDate(10),
    fechaVencimiento: futureDate(20),
    monto: 8500,
    saldoPendiente: 8500,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-002',
  },
  {
    id: '103',
    clientId: '1',
    farmacia: 'Farmacia Carol',
    vendedor: 'María García',
    fechaEmision: daysAgoDate(5),
    fechaVencimiento: futureDate(25),
    monto: 12000,
    saldoPendiente: 12000,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-003',
  },

  // Farmacia La Salud (id: 2)
  {
    id: '201',
    clientId: '2',
    farmacia: 'Farmacia La Salud',
    vendedor: 'María García',
    fechaEmision: daysAgoDate(20),
    fechaVencimiento: futureDate(10),
    monto: 5000,
    saldoPendiente: 2500,
    estado: 'parcial',
    numeroFactura: 'FAC-2024-004',
  },
  {
    id: '202',
    clientId: '2',
    farmacia: 'Farmacia La Salud',
    vendedor: 'María García',
    fechaEmision: daysAgoDate(2),
    fechaVencimiento: futureDate(28),
    monto: 7800,
    saldoPendiente: 7800,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-005',
  },

  // Farmacia del Pueblo (id: 3)
  {
    id: '301',
    clientId: '3',
    farmacia: 'Farmacia del Pueblo',
    vendedor: 'Juan Pérez',
    fechaEmision: daysAgoDate(60),
    fechaVencimiento: daysAgoDate(30),
    monto: 25000,
    saldoPendiente: 25000,
    estado: 'vencida',
    numeroFactura: 'FAC-2024-006',
  },
  {
    id: '302',
    clientId: '3',
    farmacia: 'Farmacia del Pueblo',
    vendedor: 'Juan Pérez',
    fechaEmision: daysAgoDate(40),
    fechaVencimiento: daysAgoDate(10),
    monto: 18000,
    saldoPendiente: 18000,
    estado: 'vencida',
    numeroFactura: 'FAC-2024-007',
  },
  {
    id: '303',
    clientId: '3',
    farmacia: 'Farmacia del Pueblo',
    vendedor: 'Juan Pérez',
    fechaEmision: daysAgoDate(15),
    fechaVencimiento: futureDate(15),
    monto: 9500,
    saldoPendiente: 9500,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-008',
  },
  {
    id: '304',
    clientId: '3',
    farmacia: 'Farmacia del Pueblo',
    vendedor: 'Juan Pérez',
    fechaEmision: daysAgoDate(5),
    fechaVencimiento: futureDate(25),
    monto: 6200,
    saldoPendiente: 6200,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-009',
  },

  // Farmacia Central (id: 4)
  {
    id: '401',
    clientId: '4',
    farmacia: 'Farmacia Central',
    vendedor: 'Juan Pérez',
    fechaEmision: daysAgoDate(25),
    fechaVencimiento: futureDate(5),
    monto: 11000,
    saldoPendiente: 11000,
    estado: 'pendiente',
    numeroFactura: 'FAC-2024-010',
  },

  // Farmacia Nueva Vida (id: 5)
  // No pending invoices for this one to test empty state
]
